import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
// import { getDummyText } from "../../../../utils";
import { generateTeaserDocument } from "../../../../website/partial-templates/teaser/download/teaser-download.templates";

export default {
    title: "MyTrumpf/Page Templates/Downloads/Extended Downloads",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div class="ux-t-container">
            <div class="ux-row">
                <div class="ux-col">
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-text-align--center ux-u-my-m"
                    >
                        MyTRUMPF Download Center for Customer 100771
                    </h2>
                </div>
            </div>
            <div class="ux-row">
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-my-l">
                   
                        <div class="ux-row">
                            <div class="ux-col-12 ux-col-md-6">
                                ${generateTeaserDocument({
                                    fileInfo: "04.05.2021",
                                    fileType: "PDF",
                                    fileSize: "13 MB",
                                    link: "#",
                                    withImage: true,
                                    withIcon: true,
                                    imageAlt: "09-12-02-00-CRen.pdf",
                                    imageSrc:
                                        "https://trumpf.com.cms.qa.tru/_assets/c6f81dd72b876bbc6ea1c443ba1feb37/Images/download-fallback.png",
                                    title: "09-12-02-00-CRen.pdf",
                                    description:
                                        "TruTops PFO (Edition 2019-09)",
                                })}
                            </div>
                            <div class="ux-col-12 ux-col-md-6">
                                ${generateTeaserDocument({
                                    fileInfo: "04.05.2021",
                                    fileType: "PDF",
                                    fileSize: "13 MB",
                                    link: "#",
                                    withImage: true,
                                    withIcon: true,
                                    imageAlt: "09-12-02-00-CRen.pdf",
                                    imageSrc:
                                        "https://trumpf.com.cms.qa.tru/_assets/c6f81dd72b876bbc6ea1c443ba1feb37/Images/download-fallback.png",
                                    title: "09-12-02-00-CRen.pdf",
                                    description:
                                        "TruTops PFO (Edition 2019-09)",
                                })}
                            </div>
                            <div class="ux-col-12 ux-col-md-6">
                                ${generateTeaserDocument({
                                    fileInfo: "04.05.2021",
                                    fileType: "PDF",
                                    fileSize: "13 MB",
                                    link: "#",
                                    withImage: true,
                                    withIcon: true,
                                    imageAlt: "09-12-02-00-CRen.pdf",
                                    imageSrc:
                                        "https://trumpf.com.cms.qa.tru/_assets/c6f81dd72b876bbc6ea1c443ba1feb37/Images/download-fallback.png",
                                    title: "09-12-02-00-CRen.pdf",
                                    description:
                                        "TruTops PFO (Edition 2019-09)",
                                })}
                            </div>
                            <div class="ux-col-12 ux-col-md-6">
                                ${generateTeaserDocument({
                                    fileInfo: "04.05.2021",
                                    fileType: "PDF",
                                    fileSize: "13 MB",
                                    link: "#",
                                    withImage: true,
                                    withIcon: true,
                                    imageAlt: "09-12-02-00-CRen.pdf",
                                    imageSrc:
                                        "https://trumpf.com.cms.qa.tru/_assets/c6f81dd72b876bbc6ea1c443ba1feb37/Images/download-fallback.png",
                                    title: "09-12-02-00-CRen.pdf",
                                    description:
                                        "TruTops PFO (Edition 2019-09)",
                                })}
                            </div>
                            <div class="ux-col-12 ux-col-md-6">
                                ${generateTeaserDocument({
                                    fileInfo: "07.05.2021",
                                    fileType: "jpg",
                                    fileSize: "226 KB",
                                    link: "#",
                                    withImage: true,
                                    withIcon: true,
                                    imageAlt:
                                        "TruLaser-Center-7030-keyvisual2.jpg",
                                    imageSrc:
                                        "https://trumpf.com.cms.qa.tru/_assets/c6f81dd72b876bbc6ea1c443ba1feb37/Images/download-fallback.png",
                                    title: "TruLaser-Center-7030-keyvisual2.jpg",
                                    description:
                                        "T_6162_TruLaser_Center_7030_(L26)_Showpicture_Total",
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const Default = Template.bind({});
